// src/Pages/NotFound.js
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <Container maxWidth="sm" sx={{ py: 10 }}>
    <Box sx={{ textAlign: 'center' }}>
      <Typography
        variant="h1"
        sx={{
          fontFamily: '"Audiowide", sans-serif',
          fontSize: { xs: '4rem', md: '6rem' },
          color: 'rgba(0,0,0,0.1)',
          lineHeight: 1,
          mb: 2,
        }}
      >
        404
      </Typography>
      <Typography
        variant="h5"
        sx={{
          fontFamily: '"Audiowide", sans-serif',
          color: 'black',
          mb: 2,
          fontSize: { xs: '1.25rem', md: '1.5rem' },
        }}
      >
        Page Not Found
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Roboto, sans-serif',
          color: 'rgba(0,0,0,0.5)',
          fontSize: '16px',
          mb: 4,
        }}
      >
        Looks like this page wandered off the smoker. Let's get you back on track.
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        sx={{
          backgroundColor: 'black',
          color: 'white',
          fontFamily: '"Audiowide", sans-serif',
          fontSize: '16px',
          px: 4,
          py: 1.5,
          borderRadius: '4px',
          textTransform: 'none',
          '&:hover': { backgroundColor: '#333' },
        }}
      >
        Back to Home
      </Button>
    </Box>
  </Container>
);

export default NotFound;
